//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SPECIAL_CHANNEL_ID } from "@/utils/constants";
// import WorkAudio from '@/components/post/WorkAudio'
import PostVideo from "@/components/post/PostVideo.vue";
import PostAudio from "@/components/post/PostAudio.vue";
import PostText from "@/components/post/PostText.vue";
import PostImg from "@/components/post/PostImg.vue";
import OriginalWork from "@/components/post/OriginalWork.vue";
// import PostWorkPainting from '@/components/post/PostWorkPainting.vue'
// import PostWorkPicture from '@/components/post/PostWorkPicture.vue'

export default {
  data() {
    return {
      SPECIAL_CHANNEL_ID: SPECIAL_CHANNEL_ID,
      map: [
        [SPECIAL_CHANNEL_ID.WORK_AUDIO, "语音"],
        [SPECIAL_CHANNEL_ID.WORK_VIDEO, "视频"],
        [SPECIAL_CHANNEL_ID.WORK_NOTE, "笔记"],
        [SPECIAL_CHANNEL_ID.WORK_WRITING, "写字"],
        [SPECIAL_CHANNEL_ID.WORK_MUSIC, "音乐"],
        [SPECIAL_CHANNEL_ID.WORK_PAINTING, "绘画"],
        [SPECIAL_CHANNEL_ID.WORK_PICTURE, "配图"],
        [SPECIAL_CHANNEL_ID.WORK_ESSAY, "随笔"],
        [SPECIAL_CHANNEL_ID.ORIGINAL_WORK, "原创"],
        [SPECIAL_CHANNEL_ID.ORIGINAL_NEW_POEM, "新诗"],
        [SPECIAL_CHANNEL_ID.DAILY_WORK, "日赏"]
      ]
    };
  },
  props: {
    post: {
      type: Object,
      default: null
    }
  },
  computed: {
    // 没有使用
    channelName() {
      let aimId = this.post.channel.objectId;

      return this.map.find(mem => mem[0] === aimId)[1];
    }
  },
  created() {
    // console.log(this.post.channel.objectId)
    this.post.channel.name = this.channelName;
  },
  methods: {
    goToPostDetail() {
      this.$router.push({
        name: "post",
        params: {
          id: this.post.objectId
        }
      });
    }
  },
  components: {
    PostVideo,
    PostAudio,
    PostText,
    PostImg,
    OriginalWork
    // PostWorkPainting,
    // PostWorkWriting,
    // PostWorkPicture,
  }
};



// WEBPACK FOOTER //
// ./src/components/post_item/PostItem.vue